import React from "react";
import Controls from "src/components/form/controls/Controls";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_RELEASE_TYPE_SPEAKER } from "src/constants/actionCache";
import ShowCacheReleaseTypeSpeaker from "../ShowCache/ShowCacheReleaseTypeSpeaker";
import ReleaseTypeSpeakerPopup from "../Popup/ReleaseTypeSpeakerPopup";

const ReleaseTypeSpeakerControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Release Type Speaker"
          isShowButton={isShowCache(
            currentActionCache,
            CACHE_RELEASE_TYPE_SPEAKER
          )}
        >
          <ShowCacheReleaseTypeSpeaker
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        <ReleaseTypeSpeakerPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default ReleaseTypeSpeakerControlPanel;
